<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex align-center">
        <canvas :id="id" height="250"></canvas>
        <div class="logo"><v-img :src="require(`@/assets/img/${ $vuetify.theme.dark ? 'driblab_white.png': 'driblab_color.png' }`)" max-width="125px"></v-img></div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

export default {
  data() {
    return {
      lineChart: null,
    };
  },
  props:{
    id:{
      type: String,
      required: true
    },
    datasets:{
      type: Array,
      default: () => null,
    },
    xAxisLabels:{
      type: Array,
      default: () => [],
      required: true
    },
    gamesName:{
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => null,
    },
  },
  mounted() {
    this.generateChart();
    this.updateChart();
  },
  watch: {
    id(newId, oldId){
      this.updateChart();
    },
    datasets(newDataSet, oldDataSet){
      this.updateChart();
    },
    xAxisLabels(newLabels,oldLabels){
      this.updateChart();
    }
  },
  methods: {
    generateChart() {
      const ctx = document.getElementById(this.id).getContext("2d");
      this.lineChart = new Chart(ctx, {
        type: 'line',
        data: {
            labels: this.xAxisLabels,
            datasets: this.datasets,
            gamesName: this.gamesName,
        },
        options: this.options,
      });

    },
    updateChart() {
      const ctx = document.getElementById(this.id).getContext("2d");
      //Update ticks (number of labels on X Axis)
      this.lineChart.scales['x-axis-0'].ticks = this.xAxisLabels;
      var Y = this.lineChart.scales['y-axis-0'];
      var X = this.lineChart.scales['x-axis-0'];

      let zeroPointY = Y.top + ((Y.bottom - Y.top) / (Y.ticks.length -1) * Y.zeroLineIndex);
      let zeroPointX = Y.right;
      let yScale = (Y.bottom - Y.top) / (Y.end - Y.start);
      let xScale = (X.right - X.left) / (X.ticks.length - 1);
      var minX = 0 * xScale + zeroPointX;
      var maxX = this.xAxisLabels.length * xScale + zeroPointX;
      var linearGradient = ctx.createLinearGradient(minX, 0, maxX, 0);

      //If there is at least 2 datasets, then fill intersections between them
      if(this.datasets.length > 1){
        var intersects = this.findIntersects(this.datasets[0].data, this.datasets[1].data);
        var backgroundColors = ["rgba(244, 67, 54, 0.4)", "rgba(133, 231, 131, 0.7)"];

        if(intersects.length > 0){
          intersects.forEach(function (result, index) {
              var colorStopPosition = ((result.x * xScale + zeroPointX) - minX) / (maxX - minX);

              //Check which line is bigger to choose the color (red or green)
              if(Number(result.data1) < Number(result.data2)){
                linearGradient.addColorStop(colorStopPosition, backgroundColors[0]);
                linearGradient.addColorStop(colorStopPosition, backgroundColors[1]);
              }else if(Number(result.data1) == Number(result.data2)){
                //Check next intersection if this is no the last
                if(index < (intersects.length - 1)){
                  //Next value line 1 is smaller than next value line2
                  if(intersects[index + 1].data1 < intersects[index + 1].data2){
                    linearGradient.addColorStop(colorStopPosition, backgroundColors[0]);
                    linearGradient.addColorStop(colorStopPosition, backgroundColors[1]);
                  }
                }else{
                  //Is the last intersection, check next value after intersection
                  if(Number(result.nextData1) > Number(result.nextData2)){
                    linearGradient.addColorStop(colorStopPosition, backgroundColors[0]);
                    linearGradient.addColorStop(colorStopPosition, backgroundColors[1]);
                  }else{
                    linearGradient.addColorStop(colorStopPosition, backgroundColors[1]);
                    linearGradient.addColorStop(colorStopPosition, backgroundColors[0]);
                  }

                }

              }else{
                linearGradient.addColorStop(colorStopPosition, backgroundColors[1]);
                linearGradient.addColorStop(colorStopPosition, backgroundColors[0]);
              }

            });
        }else{
          if(this.datasets[0].data[0] > this.datasets[1].data[0]){
            linearGradient = backgroundColors[1];
          }else{
            linearGradient = backgroundColors[0];
          }
        }
        //Update background to fill with the new gradient
        this.datasets.forEach(set => {
          set.backgroundColor = linearGradient;
        });

      }

      //Empty labels array
      this.lineChart.data.labels = [];
      this.lineChart.data.labels.length = 0;
      //Reload labels
      this.xAxisLabels.forEach((xLabel) => {
        this.lineChart.data.labels.push(xLabel);
      });

      //Empty labels array
      this.lineChart.data.gamesName = [];
      this.lineChart.data.gamesName.length = 0;
      //Reload gamesName
      this.gamesName.forEach((gameName) => {
        this.lineChart.data.gamesName.push(gameName);
      });

      this.lineChart.update();
    },
    /* Return coordinates X and Y where the lines intersect */
    findIntersects(line1, line2) {
      var intersects = [];
      var self = this;
      let result;
      line1.forEach(function(val, idx) {
          var line1StartX = idx;
          var line1StartY = line1[idx];
          var line1EndX = idx + 1;
          var line1EndY = line1[idx + 1];
          var line2StartX = idx;
          var line2StartY = line2[idx];
          var line2EndX = idx + 1;
          var line2EndY = line2[idx + 1];

          result = self.checkLineIntersection(line1StartX, line1StartY, line1EndX, line1EndY, line2StartX, line2StartY, line2EndX, line2EndY);

          if (result.onLine1 && result.onLine2) {
              intersects.push(result);
          }
      });

      return intersects;
    },
    checkLineIntersection(line1StartX, line1StartY, line1EndX, line1EndY, line2StartX, line2StartY, line2EndX, line2EndY) {
        // if the lines intersect, the result contains the x and y of the intersection (treating the lines as infinite)
        // and booleans for whether line segment 1 or line segment 2 contain the point
        var denominator, a, b, numerator1, numerator2, result = {
            x: null,
            y: null,
            onLine1: false,
            onLine2: false
        };
        denominator = ((line2EndY - line2StartY) * (line1EndX - line1StartX)) - ((line2EndX - line2StartX) * (line1EndY - line1StartY));
        if (denominator == 0) {
            return result;
        }

        a = line1StartY - line2StartY;
        b = line1StartX - line2StartX;
        numerator1 = ((line2EndX - line2StartX) * a) - ((line2EndY - line2StartY) * b);
        numerator2 = ((line1EndX - line1StartX) * a) - ((line1EndY - line1StartY) * b);
        a = numerator1 / denominator;
        b = numerator2 / denominator;

        // if we cast these lines infinitely in both directions, they intersect here:
        result.x = line1StartX + (a * (line1EndX - line1StartX));
        result.y = line1StartY + (a * (line1EndY - line1StartY));
        result.data1 = line1StartY;
        result.data2 = line2StartY;
        //Next value of dataset1 after intersection
        result.nextData1 = line1EndY;
        //Next value of dataset1 after intersection
        result.nextData2 = line2EndY;

        /* It is worth noting that this should be the same as:
          x = line2StartX + (b * (line2EndX - line2StartX));
          y = line2StartX + (b * (line2EndY - line2StartY)); */

        // If line1 is a segment and line2 is infinite, they intersect if:
        if (a >= 0 && a < 1) {
            result.onLine1 = true;
        }
        // If line2 is a segment and line1 is infinite, they intersect if:
        if (b >= 0 && b < 1) {
            result.onLine2 = true;
        }
        // If line1 and line2 are segments, they intersect if both of the above are true
        return result;
    },

  },
};
</script>
<style>
  .logo{
    position: absolute;
    top: 86%;
    right: 3%;
  }
</style>
